import { methods, ServiceMaker } from './index';

const { POST, GET } = methods;

export const quickpay = data => ServiceMaker(`/v1/api/pg/order/request/quickpay`, POST, null, data);

export const getStatus = async id => ServiceMaker(`/v1/api/pg/order/quickpaystatus/${id}`, GET);

//Show the easebuzz status once the payment is completed
export const easebuzzPaymentStatusNew = async id => ServiceMaker(`/v1/api/payments/easebuzz/quickpay/status/${id}`, GET);

// export const easebuzzGetStatus = async id => ServiceMaker(`/v1/api/payments/easebuzz/quickpay/status/${id}`, GET);

//creating the easebuzz payment gateway request API
export const createEasyBuzzQuickPayRequest = async (data) => {
    const result = await ServiceMaker('/v1/api/payments/easebuzz/request/quickpay',
        POST,
        null,
        data
    );
    console.log("got result : ", result);
    return result;
};

//check the count of the service 6 transactions for paytm and 4 transactions for easebuzz
export const getCount = async () =>
    ServiceMaker(`/v1/api/gatewaytype/getcount`, GET);